module.exports = require("lodash.flatmap");